import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  style: {"width":"24px"}
}

import { computed, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useGeneralStore } from '@/pinia'
import { useStore } from 'vuex'
import ButtonText from '@/design-system/atoms/buttons/ButtonText.vue'
import TableCustomMini, { TableItem } from '@/design-system/molecules/TableCustomMini.vue'
import { Attachment } from '@/services/attachments.service'

type Props = {
  fields: any[]
  items?: Attachment[]
}

export default /*@__PURE__*/_defineComponent({
  __name: 'TableFilesMini',
  props: {
    fields: {},
    items: {}
  },
  emits: ['archiveFile', 'deleteFile', 'downloadFile', 'loadMoreFiles'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emits = __emit
const { t } = useI18n()

const piniaStore = useGeneralStore()
const store = useStore()

const filesTable = ref()
const fileItems = computed<TableItem[]>(() => {
  if (!props.items) return []
  return props.items.map((item) => {
    return {
      id: item.attachmentId,
      name: item.name,
      entityId: item.entityId,
      fileType: item.fileType,
      active: true // Currently, we expect all files in the list to be active (not archived or deleted)
    }
  })
})

const currentOverlayModalPinia = computed(() => {
  return piniaStore.currentOverlayModalPinia
})
const currentOverlayModalOnModalPinia = computed(() => {
  return piniaStore.currentOverlayModalOnModalPinia
})
const selectedId = computed(() => {
  return piniaStore.selectedFile?.attachmentId ?? ''
})
const showOverlayModalPinia = computed(() => {
  return piniaStore.showOverlayModalPinia
})
const showOverlayModalOnModalPinia = computed(() => {
  return piniaStore.showOverlayModalOnModalPinia
})

function checkValidFileType(item: TableItem) {
  return (
    item.fileType === 'gif' ||
    item.fileType === 'jpg' ||
    item.fileType === 'jpeg' ||
    item.fileType === 'pdf' ||
    item.fileType === 'png' ||
    item.fileType === 'svg'
  )
}
function setFullFileById(id: string) {
  if (!props.items) return
  let file = props.items.find((file) => file.attachmentId === id)
  if (file) piniaStore.setSelectedFile(file)
}
function showModalPreviewFile(item: TableItem) {
  if (!props.items) return
  let file = props.items.find((file) => file.attachmentId === item.id)
  if (!file) return
  filesTable.value.closeMenu()
  piniaStore.setSelectedFile(file)
  if (showOverlayModalPinia.value && currentOverlayModalPinia.value === 'editTicket') {
    // For tickets, modal on modal was a joint decision on prod/tech review 2024-08-19
    piniaStore.setCurrentOverlayModalOnModalPinia('previewTicketFilePinia')
    piniaStore.setShowOverlayModalOnModalPinia(true)
    return
  }
  piniaStore.setCurrentOverlayModalPinia('previewFilePinia')
  piniaStore.setShowOverlayModalPinia(true)
}

watch(showOverlayModalPinia, () => {
  if (!showOverlayModalPinia.value) {
    piniaStore.setSelectedFile(null)
  }
})
watch(showOverlayModalOnModalPinia, () => {
  if (
    !showOverlayModalOnModalPinia.value &&
    currentOverlayModalOnModalPinia.value === 'previewTicketFilePinia'
  ) {
    piniaStore.setSelectedFile(null)
  }
})
watch(
  () => piniaStore.selectedFile,
  () => {
    if (!piniaStore.selectedFile) {
      filesTable.value.closeMenu()
    }
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TableCustomMini, {
    ref_key: "filesTable",
    ref: filesTable,
    class: "table-custom-mini",
    fields: _ctx.fields,
    hasArchiveButton: _unref(store).getters.hasFileEditorAccess,
    hasCreateButton: _unref(store).getters.hasFileCreatorAccess,
    hasDeleteButton: _unref(store).getters.hasFileAdminAccess,
    hasDownloadButton: _unref(store).getters.hasFileReaderAccess,
    items: fileItems.value,
    itemType: _unref(t)('general__data__files'),
    selectedId: selectedId.value,
    onArchiveItem: _cache[0] || (_cache[0] = ($event: any) => (emits('archiveFile'))),
    onDeleteItem: _cache[1] || (_cache[1] = ($event: any) => (emits('deleteFile'))),
    onDownloadItem: _cache[2] || (_cache[2] = ($event: any) => (emits('downloadFile'))),
    onLoadMore: _cache[3] || (_cache[3] = ($event: any) => (emits('loadMoreFiles'))),
    onMenuClosed: _cache[4] || (_cache[4] = ($event: any) => (_unref(piniaStore).setSelectedFile(null))),
    onMenuOpened: _cache[5] || (_cache[5] = ($event: any) => (setFullFileById($event)))
  }, {
    preview: _withCtx(({ item }) => [
      (checkValidFileType(item))
        ? (_openBlock(), _createBlock(ButtonText, {
            key: 0,
            class: _normalizeClass(["table-custom-mini__button", { selected: item.id === selectedId.value }]),
            iconLeft: require('@/design-system/assets/icons/Icon-Arrow-up-right.svg'),
            size: "extra-small",
            whiteContent: false,
            onOnClicked: ($event: any) => (showModalPreviewFile(item))
          }, null, 8, ["class", "iconLeft", "onOnClicked"]))
        : (_openBlock(), _createElementBlock("span", _hoisted_1))
    ]),
    _: 1
  }, 8, ["fields", "hasArchiveButton", "hasCreateButton", "hasDeleteButton", "hasDownloadButton", "items", "itemType", "selectedId"]))
}
}

})